import { useComposablePage } from '@bnnvara/composable';
import React from 'react';

import withBrandedComposablePage from '../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../layouts/ComposablePageLayout';
import PortalPageQuery from './PortalPage.gql';
import pageData from './PortalPage.json';

const PortalPage = () => {
  const { render } = useComposablePage();
  const content = render(pageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: PortalPageQuery,
})(PortalPage);
